import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ParameterTypeEnum } from 'src/app/shared/enums/parameter-type.enum';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { AutomaticRateService } from '../../services/automatic-rate.service';
import { ParameterService } from '../../services/parameter.service';
import { WalletCbpayRatesService } from '../../services/wallet-cbpay-rates.service';
import {
  AdminEditPermissionsService,
  avisarErrorTasas,
  TEXTO_SIN_PERMISO_TASAS,
} from 'src/app/shared/services/admin-edit-permissions.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-rate-update-type',
  templateUrl: './rate-update-type.component.html',
  styleUrls: ['./rate-update-type.component.css'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class RateUpdateTypeComponent {
  usdtType = '';
  fiatType = '';
  fiatPaymentType = '';
  autoRate = 0;
  autoRateSales = 0;

  @Input() showOnlyUSDT = false;
  @Input() showOnlyUSDTSale = false;

  /**
   * Candado de prod (los 4 encargados, `correoAutorizado`). En QA edita
   * cualquiera. Las lambdas responden 403 a los demás en `POST /parametro`.
   */
  puedeEditar: boolean;
  readonly textoSinPermiso = TEXTO_SIN_PERMISO_TASAS;

  constructor(
    private parameterService: ParameterService,
    private spinnerService: SpinnerService,
    private automaticRate: AutomaticRateService,
    private cbpayService: WalletCbpayRatesService,
    private permisos: AdminEditPermissionsService,
  ) {
    this.puedeEditar = this.permisos.valorInicial;
    this.permisos.puedeEditar().then((puede) => (this.puedeEditar = puede));
    this.getUsdtValue();
    this.getFiatValue();
    this.getAutoRate();
    this.getAutoRateSales();
    this.getfiatPaymentType();
  }

  async getfiatPaymentType() {
    const ref = this.spinnerService.start();
    const parameter = await this.parameterService.getParameter(
      ParameterTypeEnum.FIAT_AUTOMATICO
    );
    this.fiatPaymentType = parameter.valor;
    this.spinnerService.stop(ref);
  }
  async getUsdtValue() {
    const ref = this.spinnerService.start();
    const parameter = await this.parameterService.getParameter(
      ParameterTypeEnum.ACTUALIZACION_USDT
    );
    this.usdtType = parameter.valor;
    this.spinnerService.stop(ref);
  }
  async getFiatValue() {
    const parameter = await this.parameterService.getParameter(
      ParameterTypeEnum.ACTUALIZACION_VES
    );
    this.fiatType = parameter.valor;
  }

  async change(type: string, value: string) {
    // FIAT_AUTOMATICO elige el riel de pago, no la tasa: queda libre para
    // cualquier operador, igual que los toggles de rieles (la lambda tampoco
    // lo bloquea). El candado aplica solo a las claves de tasas.
    if (type !== 'FIAT_AUTOMATICO') {
      // Se vuelve a consultar en el momento (el toggle deshabilitado no alcanza).
      const puede = await this.permisos.puedeEditar();
      this.puedeEditar = puede;
      if (this.permisos.bloqueado(puede, TEXTO_SIN_PERMISO_TASAS)) {
        this.recargarTipo(type);
        return;
      }
    }
    const spinner = this.spinnerService.start();
    try {
      await this.parameterService.saveParameter(type, value, { errorReal: true });
    } catch (err: any) {
      // El spinner se suelta antes del aviso; el toggle vuelve a lo guardado.
      this.spinnerService.stop(spinner);
      this.recargarTipo(type);
      // 403 de la lambda (no es encargado): el mensaje del servidor.
      await avisarErrorTasas(err, 'No se pudo cambiar la forma de actualización.');
      return;
    }
    // El valor ya quedó guardado: si falla el arranque de CBPAY no se dice
    // "no se pudo guardar", se dice qué fue lo que falló.
    if (type === 'ACTUALIZACION_VES' && value === 'CBPAY') {
      try {
        await this.cbpayService.getStartAutoCbPayRates();
      } catch {
        this.spinnerService.stop(spinner);
        await Swal.fire({
          icon: 'warning',
          title: 'Guardado, con un problema',
          text: 'Se guardó CBPAY, pero no se pudo iniciar la actualización automática. Intenta de nuevo en unos minutos.',
          confirmButtonColor: '#1e5a3f',
        });
        return;
      }
    }
    this.spinnerService.stop(spinner);
  }

  /** Vuelve a leer el valor guardado del parámetro (tras un error o sin permiso). */
  private recargarTipo(type: string): void {
    if (type === 'ACTUALIZACION_USDT') this.getUsdtValue();
    else if (type === 'ACTUALIZACION_VES') this.getFiatValue();
    else if (type === 'FIAT_AUTOMATICO') this.getfiatPaymentType();
  }

  async getAutoRate() {
    const ref = this.spinnerService.start();
    const rate = await this.automaticRate.getAutomaticRate();
    this.autoRate = rate.tasa;
    this.spinnerService.stop(ref);
  }

  async getAutoRateSales() {
    const ref = this.spinnerService.start();
    const rate = await this.automaticRate.getAutomaticRateSales();
    this.autoRateSales = rate.tasa;
    this.spinnerService.stop(ref);
  }
}
